var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visibleStatus,
      expression: "visibleStatus"
    }],
    staticClass: "preview",
    class: {
      flip: _vm.flipStatus
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('p', {
    staticClass: "type"
  }, [_vm._v("공정도명")]), _c('p', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.processInfo.processName)
    }
  }), _c('button', {
    on: {
      "click": function () {
        return _vm.flipStatus = !_vm.flipStatus;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.flipStatus ? "펼치기" : '접어두기') + " ")]), _c('button', {
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("닫기")])]), _c('div', {
    staticClass: "control"
  }, [_c('ul', {
    staticClass: "info"
  }, [_c('li', [_vm._v("생성/수정일: " + _vm._s(_vm.processData.createdDate ? _vm.processData.createdDate : '') + " " + _vm._s(_vm.processData.updatedDate ? '/ ' + _vm.processData.updatedDate : ''))]), _c('li', [_vm._v("작성자 : " + _vm._s(_vm.processData.userName ? _vm.processData.userName : ''))])]), _c('ZoomSlider', {
    attrs: {
      "init": 1,
      "min": 0.2,
      "max": 3
    },
    on: {
      "full-screen": _vm.fullScreen,
      "change": _vm.sizeChange
    }
  })], 1), _c('div', {
    staticClass: "canvas",
    class: {
      load: _vm.loading
    },
    attrs: {
      "id": "protocol-preview-area"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }